import type { ReactElement } from 'react';

import { plural } from '@/lib/plural';

import { UNASSIGNED_REASONS } from '../presentation';
import type { CommitResult } from '../types';
import { FlaggedRows } from './ImportPreview';
import { formatDateTime } from '@/lib/time';

// Paso final de "Importar desde Excel": qué quedó en la Lista Maestra. Lista lo que el
// servidor aplicó con avisos (puede diferir de la previsualización si algo cambió en el
// medio) y, si un lote ya se había importado, lo dice en vez de anunciar documentos.

export function ImportDone({
  result,
  rowNumbers,
}: {
  result: CommitResult;
  rowNumbers: readonly number[];
}): ReactElement {
  if (result.replayed) {
    const when = result.importedAt ? ` el ${formatDateTime(result.importedAt)}` : '';
    return (
      <div className="import-summary" role="status">
        <strong>Este archivo ya se había importado</strong>
        <span>{`Se importó${when}. No se creó nada nuevo.`}</span>
      </div>
    );
  }
  const n = result.counts.entriesCreated;
  const unassigned = result.plan.rows.some((r) =>
    r.issues.some((i) => UNASSIGNED_REASONS.has(i.reason)),
  );
  return (
    <div className="form-grid">
      <div className="import-summary" role="status">
        <strong>Importación completa</strong>
        <span>{`${plural(n, 'documento quedó', 'documentos quedaron')} en la Lista Maestra.`}</span>
        {unassigned && (
          <span className="soft">
            Completa los responsables que faltaron desde la ficha de cada documento.
          </span>
        )}
      </div>
      <FlaggedRows rows={result.plan.rows} rowNumbers={rowNumbers} />
    </div>
  );
}
